var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 11.27a.959.959 0 0 0-.959.958v6.709h-1.916v-4.792a.958.958 0 0 0-.959-.958H9.583a.958.958 0 0 0-.958.958v4.792H6.708v-6.709a.958.958 0 0 0-1.917 0v7.667a.958.958 0 0 0 .959.958h11.5a.958.958 0 0 0 .958-.958v-7.667a.958.958 0 0 0-.958-.958zm-4.792 7.667H10.54v-3.834h1.917v3.834zm8.481-7.437a.958.958 0 0 1-1.351.086L11.5 4.418l-8.089 7.13a.959.959 0 1 1-1.265-1.438l8.721-7.666a.958.958 0 0 1 1.265 0l8.72 7.666a.958.958 0 0 1 .087 1.39z",
    fill: "#014B8A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.b8024b8c2a6e2abc34f1734c6667e4ee.svg";
export { ForwardRef as ReactComponent };